import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import {
  EMPLOYED_PROPS,
  EMPLOYMENT_TYPE_OPTIONS,
  EMPLOYMENT_TYPE_VALIDATION,
} from './constants';

import { ERROR_PROPS } from '../../PrimaryEmployment/constants';
import useEmploymentStatusFields from '../../PrimaryEmployment/useEmploymentStatusFields';
import useMonthlyIncomeValidation from '../../useMonthlyIncomeValidation';
import EmploymentAddressFields from '../EmploymentAddressFields';
import { MONTHS_OPTIONS } from '../EmploymentMonths/constants';

const EmployedPrimary: React.FunctionComponent = function () {
  const { error, validation, yearsName, monthsName, yearsOptions } =
    useEmploymentStatusFields({
      type: 'primary',
      employmentType: 'employed',
      index: undefined,
      arrayName: undefined,
    });
  const { validation: monthlyIncomeValidation, onBlur } =
    useMonthlyIncomeValidation({
      type: 'primary',
      employmentType: 'employed',
      index: undefined,
      arrayName: undefined,
    });
  return (
    <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
      <Field.Validator validation={EMPLOYMENT_TYPE_VALIDATION}>
        <Field.Select
          {...EMPLOYED_PROPS.employedType}
          options={EMPLOYMENT_TYPE_OPTIONS}
        />
      </Field.Validator>
      <Field.Validator validation={monthlyIncomeValidation}>
        <Field.NumberInput
          {...EMPLOYED_PROPS.monthlyIncome}
          onBlur={() => onBlur()}
        />
      </Field.Validator>

      <Widget.CreditEmploymentDetailsEmployedDetailsEmployerName
        {...EMPLOYED_PROPS.employerName}
        className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
      />
      <Widget.CreditEmploymentDetailsEmployedDetailsMainOccupation
        {...EMPLOYED_PROPS.mainOccupation}
        className="col-span-2 sm:col-span-1 md:col-span-2 xl:col-span-1"
      />
      <div className="col-span-2">
        <EmploymentAddressFields
          employmentStatus="employed"
          employmentClass="primary"
        />
      </div>
      <span className="col-span-2 text-12-18-em text-neutral-700 w-full mb-2">
        When did you start your employment?
      </span>
      <Field.Select
        options={MONTHS_OPTIONS}
        name={monthsName}
        placeholder="Month"
      />
      <Field.Select
        options={yearsOptions}
        name={yearsName}
        placeholder="Year"
      />
      {error && <Text text={error} className={ERROR_PROPS.className} />}
      <div className="hidden">
        <Widget.CreditEmploymentDetailsEmployedDetailsMonthsEmployed
          validation={validation}
        />
      </div>
    </div>
  );
};

export default EmployedPrimary;
